import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { inject, injectable } from "tsyringe";

import { PolicyBridgeService } from "src/containers/insurances/services/policy-bridge/policy-bridge-service";
import { PolicyRepository } from "src/containers/insurances/repositories/policy/policy-repository";
import { EpsPlan, PgaPolicy } from "src/shared/models";
import { autoBind } from "src/shared/decorators/autobind";

@injectable()
export class PolicyService {
    constructor(
        @inject("PolicyRepository") private repository: PolicyRepository,
        @inject("PolicyBridgeService")
        private bridgeService: PolicyBridgeService
    ) {}

    @autoBind
    getPolicies(
        userIdentity: string,
        line = "all"
    ): Observable<Array<PgaPolicy>> {
        return this.repository
            .getPolicies(userIdentity, line)
            .pipe(map((data) => data.map(this.bridgeService.standarizePolicy)));
    }

    @autoBind
    getStandardPolicies(userIdentity: string): Observable<Array<PgaPolicy>> {
        return this.repository
            .getStandardPolicies(userIdentity)
            .pipe(map((data) => data.map(this.bridgeService.standarizePolicy)));
    }

    @autoBind
    getPlans(userIdentity: string): Observable<Array<EpsPlan>> {
        return this.repository
            .getPlans(userIdentity)
            .pipe(
                map((data) =>
                    data.map(
                        (json) =>
                            this.bridgeService.standarizePolicy(json) as EpsPlan
                    )
                )
            );
    }
}
